module.exports = __webpack_public_path__ + "src/assets/img/share/tips/nervousness/ce36b76f9b916cdfab0e8655e15e7395.png";